import type {
  InterventionTemplateDetail,
  InterventionTemplateNode,
  InterventionTemplateNodeType,
} from "./intervention-template.type";

import { groupBy } from "@/utilities/array";

export const groupTemplatesByType = (
  templates: InterventionTemplateNode[] = []
) => {
  return groupBy(templates, ({ type }) => type);
};

export const filterTemplatesByTypes = (
  templates: InterventionTemplateNode[],
  types: InterventionTemplateNodeType[]
) => {
  return templates.filter((template) => types.includes(template.type));
};

export const getInterventionTemplateChildren = (
  template?: InterventionTemplateDetail | InterventionTemplateNode
): InterventionTemplateNode[] => {
  if (!template) return [];
  if (!("templates" in template)) return [];
  return template.templates ?? [];
};
